import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

export const adminGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  // List of authorized admin emails
  const authorizedAdmins = [
    'kevin.cheng@harpercollins.com',
    'mdjafar.abdali@harpercollins.com',
    'alex.spence@harpercollins.com',
    'dinesh.kumar@harpercollins.com',
    'alison.park@harpercollins.com',
    'sam.wong@harpercollins.com',
  ];

  // Get the current user's account
  const accounts = msalService.instance.getAllAccounts();
  
  console.log('Admin Guard - Checking authorization...');
  console.log('Admin Guard - All accounts:', accounts);
  
  if (accounts.length === 0) {
    // User is not authenticated, redirect to home
    console.warn('Admin Guard - No authenticated accounts found');
    router.navigate(['/']);
    return false;
  }

  // Get the user's email from the account
  const userEmail = accounts[0].username?.toLowerCase();
  
  console.log('Admin Guard - User email:', userEmail);
  console.log('Admin Guard - Authorized admins:', authorizedAdmins);
  console.log('Admin Guard - Is authorized?', userEmail && authorizedAdmins.includes(userEmail));

  // Check if the user's email is in the authorized list
  if (userEmail && authorizedAdmins.includes(userEmail)) {
    console.log('Admin Guard - Access GRANTED');
    return true; // Allow access
  }

  // User is not authorized, redirect to home or show unauthorized page
  console.warn('Admin Guard - Unauthorized access attempt to admin route by:', userEmail);
  alert('You are not authorized to access the admin area.');
  router.navigate(['/']);
  return false;
};

